import { Capacitor } from '@capacitor/core'
import { gatewayConfig } from '../gatewayClient/config'
import { oidcConfig } from '../oauth/config'
import AppGroupUserDefaults from '../../plugins/appGroupUserDefaults/AppGroupUserDefaultsPlugin'
import { liveToken } from '../../state/rocketchatState/rocketchatSignals'
import { getRocketChatUrl } from '../../utils'
import { bs } from '../../state/bound.store'

export default function shareExtensionListener() {
    if (Capacitor.getPlatform() !== 'ios') return

    const chatAuthorisationToken = liveToken?.value?.authToken
    const userId = liveToken?.value?.userId
    const organisationId = liveToken?.value?.org

    if (!chatAuthorisationToken || !userId || !organisationId) return

    const chatBaseUrl = getRocketChatUrl(organisationId)

    const authorisationToken = bs().IDtoken
    const refreshToken = bs().refreshToken

    if (!authorisationToken || !refreshToken) return

    const authenticationBaseUrl = oidcConfig().authority
    const clientId = oidcConfig().client_id
    const clientSecret = oidcConfig().client_secret

    if (!authenticationBaseUrl || !clientId || !clientSecret) return

    const gatewayBaseUrl = gatewayConfig().baseUrl

    if (!gatewayBaseUrl) return

    const payload = {
        chatAuthorisationToken,
        userId,
        organisationId,
        chatBaseUrl,
        authenticationBaseUrl,
        authorisationToken,
        refreshToken,
        clientId,
        clientSecret,
        gatewayBaseUrl,
    }

    AppGroupUserDefaults.set({
        key: 'share-extension',
        value: JSON.stringify(payload),
    })
}
